import { 
  LOGIN, ERROR, LOGOUT, USER_LIST, FLUSH, UPDATE_USER, MESSAGE, 
  USER_DETAILS, USER_TYPES, USER_FRIENDS, USER_REVIEWS, 
  SHARE_PROFILE_USER_DETAILS, SHARE_POST_DETAILS, 
  SHARE_PROPERTY_DETAILS, PRIVACY_POLICY, TERM_CONDITIONS, TOTAL_USER
 } from './constants';

const initialState = {
  loggedIn: false,
  roleId: 0,
  error: null,
  list: [],
  message: null,
  userTypes: [],
  details: {
    reviews: [],
    friends: []
  },
  shareUserDetails: {
    userDetail: {}
  },
  sharePostDetails: {
    userDetail: {}
  },
  shareVacancyDetails: {
    userDetail: {},
    propertyImages: {}
  },
  privacyPolicy: {},
  termsCont: {},
  totalUsers: 0,
};

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case LOGIN: 
      return {
        ...state,
        loggedIn: true,
        firstName: action.firstName,
        lastName: action.lastName,
        roleId: action.roleId,
        isAdmin: action.isAdmin,
        email: action.email
      };
    
    case ERROR:
      return {
        ...state,
        error: action.error
      };

    case LOGOUT: 
      return {
        ...state,
        loggedIn: false,
        roleId: 0,
        isAdmin: false
      };

    case USER_LIST:
      return {
        ...state,
        list: action.result
      };

    case FLUSH:
      return {
        ...initialState
      };

    case UPDATE_USER:
      return {
        ...state,
        userName: action.result
      };

    case MESSAGE:
      return {
        ...state,
        message: action.message
      };

    case USER_DETAILS:
      return {
        ...state,
        details: action.result
      };

    case USER_TYPES: 
      return {
        ...state,
        userTypes: action.result
      };

    case USER_REVIEWS: 
      return {
        ...state,
        details: Object.assign({}, state.details, {
          reviews: action.result
        })
      };

    case USER_FRIENDS: 
      return {
        ...state,
        details: Object.assign({}, state.details, {
          friends: action.result
        })
      };

    case SHARE_PROFILE_USER_DETAILS: 
      return {
        ...state,
        shareUserDetails: action.result
      };

    case SHARE_POST_DETAILS: 
      return {
        ...state,
        sharePostDetails: action.result
      };

    case SHARE_PROPERTY_DETAILS: 
      return {
        ...state,
        shareVacancyDetails: action.result
      };

    case PRIVACY_POLICY:
      return {
        ...state,
        privacyPolicy: action.result
      };

    case TERM_CONDITIONS:
      return {
        ...state,
        termsCont: action.result
      };

    case TOTAL_USER:
      return {
        ...state,
        totalUsers: action.result
      };
      
    default: 
      return {
        ...state
      }
  }
}
